module.exports = __webpack_public_path__ + "img/033.2aa06875.png";